var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckedShield(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3346 8.66664C13.3346 12 11.0013 13.6666 8.22797 14.6333C8.08274 14.6825 7.92499 14.6802 7.7813 14.6266C5.0013 13.6666 2.66797 12 2.66797 8.66664V3.99997C2.66797 3.82316 2.73821 3.65359 2.86323 3.52857C2.98826 3.40355 3.15782 3.33331 3.33464 3.33331C4.66797 3.33331 6.33464 2.53331 7.49464 1.51997C7.63587 1.39931 7.81554 1.33301 8.0013 1.33301C8.18707 1.33301 8.36673 1.39931 8.50797 1.51997C9.67464 2.53997 11.3346 3.33331 12.668 3.33331C12.8448 3.33331 13.0143 3.40355 13.1394 3.52857C13.2644 3.65359 13.3346 3.82316 13.3346 3.99997V8.66664Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.00033L7.33333 9.33366L10 6.66699",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedShield);
export default __webpack_public_path__ + "static/media/checked-shield.38d2a93f61a0dfb8d3bc8fca2428f14f.svg";
export { ForwardRef as ReactComponent };